import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error: any): void {
    // Optional: Log to console in dev
    if (!environment.production) {
      console.error('Global error:', error);
    }
  }
}